var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SideFilter,{ref:"loadoutSideFilter",staticClass:"mt-0",attrs:{"filterList":_setup.filtersLoad},on:{"input":_setup.updateFilter,"inputWeek":_setup.updateWeekFilter,"inputYear":_setup.updateYearFilter,"clear":function($event){return _setup.removeFilters()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }